import { ColleaguesBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import Slider from "../slider/Slider";
import Slide from "../slider/Slide";
import { resolveImageUrl } from "@/storyblok/resolvers";

export default function Colleagues({ data }: { data: ColleaguesBlockData }) {
  return (
    <section
      id={data.anchor}
      className="section--colleagues-grid"
      {...makeEditable(data)}
    >
      <h3>{data.title}</h3>
      <Slider>
        {data.colleagues.map((colleague) => (
          <Slide className="colleague" key={colleague._uid}>
            <div
              className="swiper-slide-inner"
              {...makeEditable(colleague)}
              style={{
                "--color-background": colleague.background_color?.color,
              }}
            >
              <img
                src={resolveImageUrl(colleague.image)}
                alt={colleague.name}
              />
              <article>
                <p>{colleague.name}</p>
                <h5>{colleague.role}</h5>
                <blockquote>
                  <p>&ldquo; {colleague.quote}&rdquo;</p>
                </blockquote>
              </article>
            </div>
          </Slide>
        ))}
      </Slider>
    </section>
  );
}
